import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import RenovationsPage from "../pages/services/renovations/page";
import PoleBarnsPage from "../pages/services/pole-barns/page";
import AdditionsPage from "../pages/services/additions/page";
import GeneralContractingPage from "../pages/services/general-contracting/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services/renovations", element: <RenovationsPage /> },
  { path: "/services/pole-barns", element: <PoleBarnsPage /> },
  { path: "/services/additions", element: <AdditionsPage /> },
  { path: "/services/general-contracting", element: <GeneralContractingPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
